import iconNames from "./iconNames";
export var iconNameData = function iconNameData() {
  var convertedObject = {};
  iconNames.forEach(function (item) {
    if (item.includes('.path')) {
      var _convertedObject$name;
      var name = item.split('.')[0].trim().replace(':', '');
      var pathNumber = item.split('.')[1].trim().replace(':', '');
      if (!convertedObject[name]) {
        convertedObject[name] = {
          name: name,
          path: []
        };
      }
      (_convertedObject$name = convertedObject[name].path) === null || _convertedObject$name === void 0 || _convertedObject$name.push(pathNumber);
    } else {
      var _name = item.trim().replace(':', '');
      if (!convertedObject[_name]) {
        convertedObject[_name] = {
          name: _name
        };
      }
    }
  });
  // console.log("convertedObject", convertedObject);
  return convertedObject;
};